import { useEffect, useState } from "react";
import { FormCheck, FormControl, FormLabel } from "react-bootstrap";
import { Button, Form, FormGroup } from "reactstrap";

import { useHistory, useParams } from "react-router";
import { useAuth } from "../hooks/useAuth";
import { EventoType } from "../hooks/useEventos";
import { database } from "../services/firebase";
import swal from "sweetalert";
import { instituicao } from "../params";
import { Encoder } from "bazinga64";

type PageParams = {
    id: string;
};

export function Inscricao() {
    const history = useHistory();
    const { user, checkLogin } = useAuth();

    const [verificando, setVerificando] = useState(false);
    const [encerrado, setEncerrado] = useState(false);
    const [respondido, setRespondido] = useState(false);
    const params = useParams<PageParams>();
    const eventoId = params.id;
    const [evento, setEvento] = useState<EventoType>({} as EventoType);

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [escolaridade, setEscolaridade] = useState("");
    const [alunoFDV, setAlunoFDV] = useState(false);

    useEffect(() => {
        //checkLogin();
    }, []);

    async function handleResponder() {
        setRespondido(true);

        //if (user) {
        console.log(email);
        const encoded = Encoder.toBase64(email);

        const inscricaoRef = database.ref(`eventos/${eventoId}/inscricoes/${encoded.asString}`);

        await inscricaoRef.update({
            nome: nome,
            email: email,
            telefone: telefone,
            escolaridade: escolaridade,
            alunoFDV: alunoFDV,
            respondidoEm: new Date().toISOString(),
        });

        // if ("sim" === presencial) {
        //     await swal({
        //         title: "Aviso",
        //         text: "Estou ciente que será indispensável a assinatura do documento “Termo de Consentimento”, uma única vez, no prazo estipulado de 02 (dois) dias aí incluído o da data do envio, via Plataforma D4Sign, bem como responder ao “Questionário Autodeclaratório de Saúde”, antes de acessar as dependências da Instituição,  a cada dia de aula da disciplina.",
        //         //@ts-ignore
        //         button: "Ciente!",
        //     });
        // }

        swal(
            "Sucesso!",
            "Recebemos sua solicitação para participação no evento Direito e Atualidades (20/09). Em breve enviaremos a confirmação da sua inscrição devido a capacidade do auditório. A FDV agradece.",
            "success"
        );
        //}
    }
    function handleAtivarNotificacoes() {}

    useEffect(() => {
        // if (user === undefined) {
        //     return;
        // }

        const pathName = window.location.pathname;

        // if (!user) {
        //     history.push({ pathname: "/login", state: { destination: pathName } });
        // }

        const moduleRef = database.ref(`eventos/${eventoId}`);
        moduleRef.once("value", (snapshot) => {
            const evento: EventoType = snapshot.val();
            setEvento(evento);

            // fetch("https://worldtimeapi.org/api/timezone/America/Sao_Paulo").then((response) => {
            //     if (200 === response.status) {
            //         response.json().then((data) => {
            //             setVerificando(false);

            //             const encerramento =
            //                 evento.dataFechamentoInscricao.substring(6, 10) +
            //                 "-" +
            //                 evento.dataFechamentoInscricao.substring(3, 5) +
            //                 "-" +
            //                 evento.dataFechamentoInscricao.substring(0, 2);

            //             if (encerramento < data?.datetime.substring(0, 10)) {
            //                 setEncerrado(true);
            //             }
            //         });
            //     }
            // });
        });
        return () => {
            moduleRef.off("value");
        };
    }, [eventoId, user?.id]);

    useEffect(() => {
        Inputmask().mask(document.querySelectorAll("#telefone"));
    });

    return (
        <div className="content-wrapper">
            <div className="content-heading">Inscrição em evento</div>
            <div className="row">
                {!evento && (
                    <div className="col-12">
                        <div className="alert alert-danger fade show" role="alert">
                            Evento não encontrado!
                        </div>
                    </div>
                )}
                {evento && (
                    <div className="col-xl-6 col-lg-6">
                        <div className="card b">
                            <div className="card-header">
                                <div className="float-right">{/*<div className={`badge badge-info ${props.status}`}>{props.status}</div>*/}</div>
                                <h4 className="m-0">{evento.titulo}</h4>
                                <small className="text-muted">{evento.data}</small>
                            </div>
                            <table className="table">
                                <tbody></tbody>
                            </table>
                            <div style={{ padding: "20px" }}>
                                <FormGroup>
                                    <FormLabel htmlFor="nome">Nome completo</FormLabel>
                                    <FormControl id="nome" onChange={(event) => setNome(event.target.value)} defaultValue={nome} required></FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <FormLabel htmlFor="email">E-mail</FormLabel>
                                    <FormControl id="email" onChange={(event) => setEmail(event.target.value)} defaultValue={email} required></FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <FormLabel htmlFor="telefone">Telefone</FormLabel>
                                    <FormControl
                                        id="telefone"
                                        data-inputmask="'mask': '(99) 9999[9]-9999'"
                                        onChange={(event) => setTelefone(event.target.value)}
                                        value={telefone}
                                        required></FormControl>
                                </FormGroup>
                                <FormGroup>
                                    <FormLabel htmlFor="escolaridade">Escolaridade</FormLabel>

                                    <select
                                        className="form-control"
                                        id="escolaridade"
                                        data-inputmask="'mask': '(99) 9999[9]-9999'"
                                        onChange={(event) => setEscolaridade(event.target.value)}
                                        value={escolaridade}
                                        required>
                                        <option>Graduação</option>
                                        <option>Especialização</option>
                                        <option>Mestrado</option>
                                        <option>Doutorado</option>
                                    </select>
                                </FormGroup>
                                <FormGroup>
                                    <FormCheck type="checkbox" label="Aluno FDV" onChange={(event) => setAlunoFDV(event.target.checked)} />
                                </FormGroup>
                            </div>

                            {!respondido && !encerrado && !verificando && (
                                <div className="card-footer text-center">
                                    <button className="btn btn-secondary" type="button" onClick={handleResponder}>
                                        Inscrever
                                    </button>
                                </div>
                            )}
                            {respondido && !encerrado && !verificando && (
                                <div className="card-footer text-center bg-success">
                                    {/*<button className="btn btn-secondary" style={{ marginRight: "6px" }} type="button" onClick={handleAtivarNotificacoes}>
                                        Ativar Notificações
                            </button>*/}

                                    <button
                                        className="btn btn-secondary"
                                        type="button"
                                        onClick={(event) => {
                                            setRespondido(false);
                                        }}>
                                        Alterar
                                    </button>
                                </div>
                            )}
                            {encerrado && (
                                <div className="card-footer text-center bg-danger-light">
                                    <p>Inscrições encerradas.</p>
                                </div>
                            )}
                            {verificando && (
                                <div className="card-footer text-center">
                                    <p>Verificando datas</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
